import * as app from './app/actions'

export default {
  app,
}
